// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay .offer-subtotal-list{border-top:1px solid #dee2e6;border-bottom:1px solid #dee2e6;font-weight:600;list-style-type:none;margin:0;padding:.5rem 1rem}#openbay .offer-subtotal-list li{display:flex;justify-content:space-between;font-weight:600;list-style-type:none;padding:.25rem 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
